/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { SectionContentInterface, SectionInterface } from '../../+models';
import { APISectionInterface } from '../../section';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class SectionApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Sections');
  }

  replaceSections(sections: APISectionInterface[], eduContentTocId: number) {
    const path = `sections/${eduContentTocId}`;
    return this.post<{ section: SectionInterface; sectionContents: SectionContentInterface[] }[]>(
      path,
      undefined,
      sections
    );
  }
}
